import { render, staticRenderFns } from "./Informator.vue?vue&type=template&id=548516d6&"
import script from "./Informator.vue?vue&type=script&lang=js&"
export * from "./Informator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports